import { type RouteRecordRaw } from 'vue-router'

const basePath = '/plant'

export const PLANTRoutes: RouteRecordRaw[] = [
  {
    path: `${basePath}/address-location`,
    name: 'PLANT-AddressLocation',
    component: () => import('@/pages/PLANT/AddressLocation.vue'),
    meta: {
      title: 'PLANT Address and Location',
      layout: 'FW',
      theme: 'PLANT',
      header: 'PLANT Manager'
    }
  },
  {
    path: `${basePath}/site-structure`,
    name: 'PLANT-SiteStructure',
    component: () => import('@/pages/PLANT/SiteStructure.vue'),
    meta: {
      title: 'PLANT Site and Structure',
      layout: 'FW',
      theme: 'PLANT',
      header: 'PLANT Manager'
    }
  },
  {
    path: `${basePath}/site-structure/create`,
    name: 'PLANT-StructureCreate',
    component: () => import('@/pages/PLANT/SiteStructure/StructureCreate.vue'),
    meta: {
      title: 'PLANT Create Structure',
      layout: 'FW',
      theme: 'PLANT',
      header: 'PLANT Manager'
    }
  },
  {
    path: `${basePath}/site-structure/:structureId`,
    name: 'PLANT-StructureDetail',
    component: () => import('@/pages/PLANT/SiteStructure/StructureDetail.vue'),
    meta: {
      title: 'PLANT Structure Detail',
      layout: 'FW',
      theme: 'PLANT',
      header: 'PLANT Manager'
    }
  },
  {
    path: `${basePath}/site-structure/node/create`,
    name: 'PLANT-NodeCreate',
    component: () => import('@/pages/PLANT/SiteStructure/NodeCreate.vue'),
    meta: {
      title: 'PLANT Create Node',
      layout: 'FW',
      theme: 'PLANT',
      header: 'PLANT Manager'
    }
  },
  {
    path: `${basePath}/site-structure/node/:nodeId`,
    name: 'PLANT-NodeDetail',
    component: () => import('@/pages/PLANT/SiteStructure/NodeDetail.vue'),
    meta: {
      title: 'PLANT Node Detail',
      layout: 'FW',
      theme: 'PLANT',
      header: 'PLANT Manager'
    }
  }
]

// Map for route lookups
const routeMap = new Map(PLANTRoutes.map(route => [route.name, route]))

export function isPLANTRoute (routeName: string | symbol): boolean {
  const route = routeMap.get(routeName)
  return route !== undefined
}

export function isPLANTAddressLocationRoute (routeName: string): boolean {
  const route = routeMap.get(routeName)
  return route !== undefined && (route.path.startsWith(basePath + '/address-location'))
}

export function isPLANTSiteStructureRoute (routeName: string): boolean {
  const route = routeMap.get(routeName)
  return route !== undefined && route.path.startsWith(basePath + '/site-structure')
}
